export default {"src":"/_next/static/media/fci.b680482e.svg","height":50,"width":55};